import { Language } from '@yleisradio/areena-types';
import { fetchPlayBackHistoryForItems } from '../fetchers';
import { useAppFeaturesContext } from '../../../client/contexts/AppFeaturesContext/AppFeaturesContext';
import { PlaybackHistoryEntries } from '../../../client/appTypings';
import useSWR from 'swr';

type RequestKey = ['playback-history', itemIds: string[], language: Language];

async function fetcher([
  ,
  itemIds,
  language,
]: RequestKey): Promise<PlaybackHistoryEntries> {
  return fetchPlayBackHistoryForItems(itemIds, language);
}

export function useFetchPlayBackHistoryForItems(itemIds: string[] | undefined) {
  const { languageCode } = useAppFeaturesContext();

  const { data, isLoading } = useSWR(
    itemIds && itemIds.length > 0
      ? (['playback-history', itemIds, languageCode] satisfies RequestKey)
      : null,
    fetcher
  );

  return { data, isLoading };
}
